/**
 * Utilidades para manejar estados de proformas B2B
 * Centraliza colores y textos para mantener consistencia
 */

/**
 * Obtiene el color del chip según el estado de la proforma
 * @param {string} status - Estado de la proforma
 * @returns {string} Color del chip de Material-UI
 */
export const getProformaStatusColor = (status) => {
  switch (status) {
    case 'DRAFT': return 'default';
    case 'SENT': return 'warning';
    case 'ACCEPTED': return 'success';
    case 'FINALIZED': return 'success';
    case 'REJECTED': return 'error';
    default: return 'default';
  }
};

/**
 * Obtiene el texto traducido del estado de la proforma
 * @param {string} status - Estado de la proforma
 * @param {function} t - Función de traducción de i18next
 * @returns {string} Texto traducido del estado
 */
export const getProformaStatusText = (status, t) => {
  switch (status) {
    case 'DRAFT': return t('draft');
    case 'SENT': return 'Pendiente';
    case 'ACCEPTED': return 'Aceptado';
    case 'FINALIZED': return 'Entregado';
    case 'REJECTED': return t('rejected');
    default: return status;
  }
};

/**
 * Verifica si una proforma puede cambiar de estado
 * @param {string} status - Estado actual de la proforma
 * @returns {boolean} True si puede cambiar de estado
 */
export const canChangeProformaStatus = (status) => {
  return status !== 'ACCEPTED' && status !== 'REJECTED';
};

/**
 * Obtiene los estados disponibles para cambiar desde el estado actual
 * @param {string} currentStatus - Estado actual de la proforma
 * @returns {string[]} Array de estados disponibles
 */
export const getAvailableProformaStatuses = (currentStatus) => {
  if (!canChangeProformaStatus(currentStatus)) {
    return [];
  }
  
  switch (currentStatus) {
    case 'DRAFT': return ['SENT'];
    case 'SENT': return ['ACCEPTED', 'REJECTED'];
    default: return ['SENT'];
  }
};
